// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import dayjs from 'dayjs';
import { MFA_SESSION } from './ConstantValues';
import { MfaSession } from './Types';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

export const getSavedMfaSession = (userId: string): MfaSession | undefined => {
  const savedMfaSession = localStorage.getItem(MFA_SESSION);
  dayjs.extend(isSameOrBefore);

  try {
    const data: Record<string, MfaSession> = savedMfaSession
      ? JSON.parse(savedMfaSession)
      : undefined;
    const userMfaSession = data?.[userId];

    if (!userMfaSession) {
      return undefined;
    }

    if (dayjs(userMfaSession.expiresAt).isSameOrBefore(dayjs())) {
      delete data[userId];
      localStorage.setItem(MFA_SESSION, JSON.stringify(data));

      return undefined;
    }

    return userMfaSession;
  } catch (_) {
    return undefined;
  }
};

export const setSavedMfaSession = (userId: string, data: MfaSession) => {
  try {
    const savedRawMfaSessions = localStorage.getItem(MFA_SESSION);

    const savedMfaSessions: Record<string, MfaSession> = savedRawMfaSessions
      ? JSON.parse(savedRawMfaSessions)
      : {};

    localStorage.setItem(
      MFA_SESSION,
      JSON.stringify({
        ...savedMfaSessions,
        [userId]: data,
      })
    );
  } catch (_) {
    return;
  }
};

export const removeSavedMfaSession = (userId: string) => {
  try {
    const savedRawMfaSessions = localStorage.getItem(MFA_SESSION);

    const savedMfaSessions: Record<string, MfaSession> = savedRawMfaSessions
      ? JSON.parse(savedRawMfaSessions)
      : {};

    delete savedMfaSessions[userId];

    localStorage.setItem(MFA_SESSION, JSON.stringify(savedMfaSessions));
  } catch (_) {
    return;
  }
};
